import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamworkCollectionAlt: {
		id: 'twc.xflow.modal.requested.trial.screen.teamwork.collection.alt',
		defaultMessage: 'Teamwork Collection',
		description: 'Alt text for Teamwork Collection logo',
	},
	heading: {
		id: 'twc.xflow.modal.requested.trial.screen.heading',
		defaultMessage: 'Your request is pending',
		description: 'Heading text for the requested trial screen',
	},
	explanation: {
		id: 'twc.xflow.modal.requested.trial.screen.explanation',
		defaultMessage:
			'The admin for your workspace needs to approve the request before you can try Teamwork Collection.',
		description: 'Explanation text about admin approval',
	},
	shareLinkPrompt: {
		id: 'twc.xflow.modal.requested.trial.screen.share.link.prompt',
		defaultMessage: 'For faster approval, share the link below with your admin',
		description: 'Prompt text to share link with admin',
	},
	copyLinkButton: {
		id: 'twc.xflow.modal.requested.trial.screen.copy.link.button',
		defaultMessage: 'Copy link',
		description: 'Copy link button text',
	},
	closeButton: {
		id: 'twc.xflow.modal.requested.trial.screen.close.button',
		defaultMessage: 'Close',
		description: 'Close button text',
	},
	linkCopied: {
		id: 'twc.xflow.modal.requested.trial.screen.link.copied',
		defaultMessage: 'Link copied!',
		description: 'Message shown when link is copied',
	},
	visualAlt: {
		id: 'twc.xflow.modal.teamwork.collection.requested.trial.screen.visual.alt',
		defaultMessage: 'A graphic that displays Jira, Confluence, Confluence, and Loom integrations',
		description: 'Alternate text for a graphics about bundled apps',
	},
	closeModal: {
		id: 'twc.xflow.modal.teamwork.collection.requested.trial.screen.close',
		defaultMessage: 'Close modal',
		description: 'Close modal button label',
	},
	requestLinkInputLabel: {
		id: 'twc.xflow.modal.requested.trial.screen.request.link.input.label',
		defaultMessage: 'Trial request link',
		description: 'Accessible label for the trial request link input field',
	},
});
